import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrnamentWaves = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 381,
	height: 411,
	viewBox: "0 0 381 411",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .4,
		d: "M99.1403 173.402L99.1403 177.402L99.1403 173.402ZM99.1403 407L99.1403 411L99.1403 407ZM157.35 -40C157.35 -42.2091 159.14 -44 161.35 -44C163.559 -44 165.35 -42.2091 165.35 -40L157.35 -40ZM230.027 33.6823L386.996 33.6823L386.996 41.6823L230.027 41.6823L230.027 33.6823ZM386.996 33.6823C428.752 33.6823 462.68 65.7272 462.68 105.542L454.68 105.542C454.68 70.5369 424.735 41.6823 386.996 41.6823L386.996 33.6823ZM462.68 105.542C462.68 145.364 428.514 177.402 386.996 177.402L386.996 169.402C424.514 169.402 454.68 140.539 454.68 105.542L462.68 105.542ZM386.996 177.402L99.1403 177.402L99.1403 169.402L386.996 169.402L386.996 177.402ZM99.1403 403L755 403L755 411L99.1403 411L99.1403 403ZM99.1403 177.402C66.0069 177.402 42.7919 191.373 28.0636 212.211C13.2245 233.205 6.81966 261.458 8.17757 290.011C9.53495 318.553 18.6325 346.959 34.2638 368.124C49.8448 389.222 71.7838 403 99.1403 403L99.1403 411C68.746 411 44.5945 395.579 27.8285 372.877C11.1127 350.243 1.60655 320.249 0.186603 290.391C-1.23282 260.545 5.41141 230.398 21.5307 207.593C37.7608 184.631 63.4135 169.402 99.1403 169.402L99.1403 177.402ZM165.35 -40C165.35 -17.1961 169.792 1.15751 179.816 13.7567C189.698 26.1767 205.558 33.6823 230.027 33.6823L230.027 41.6823C203.823 41.6823 185.345 33.5547 173.556 18.7375C161.91 4.09944 157.35 -16.3881 157.35 -40L165.35 -40Z",
		fill: "url(#paint0_linear_564_3167)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_564_3167",
		x1: 69.5744,
		y1: -21.3733,
		x2: 1228.32,
		y2: 714.75,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .0276552,
				stopColor: "#79FBAF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .296148,
				stopColor: "#79FBAF",
				stopOpacity: .15
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .855879,
				stopColor: "#79FBAF",
				stopOpacity: .21
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#79FBAF"
			})
		]
	}) })]
});
export default SvgOrnamentWaves;
